(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documentnew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="documentnew-component" data-hook="documentnew-component">
        <h3>Neue/s document anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addDocument()" ng-hide="vm.newdocument">Neue/s document anlegen</div>
        <div ng-show="vm.newdocument">
          <documentform document="vm.newdocument" parentsave="vm.saveNewDocument(document)" oncancel="vm.cancel()"></documentform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> document erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen document wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> document konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Document', 'Rlog',
        function ($log, Document, Rlog) {
          let vm = this;
          vm.addDocument = addDocument;
          vm.saveNewDocument = saveNewDocument;
          vm.cancel = cancel;
          
          function addDocument() {
            vm.newdocument = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewDocument(document) {
            $log.debug('debug: create new document: ', document);
            delete vm.newdocument;
            Document.$create(document).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new document failed: ', err);
              Rlog.error('vcutils.document', 'documentnew', 'Creation of new document failed: ', {document: vm.newdocument});
            });
          }
          
          function cancel() {
            delete vm.newdocument;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
